export const mobileSmallThreshold = '(max-width: 479px)'
export const mobileMediumThreshold = '(max-width: 767px)'
